import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import actions from './actions';
import { setToken, clearToken, getToken, checkToken } from '../../helpers/utility';
import AuthHelper from '../../helpers/authHelper';
import notification from '../../components/notification';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import isEmpty from 'lodash/isEmpty';

export function* loginRequest() {
	yield takeEvery('LOGIN_REQUEST', function*({ payload }) {
		const { history, userInfo } = payload;
		const result = yield call(AuthHelper.login, userInfo);
		if (result.token) {
			yield put({
				type: actions.LOGIN_SUCCESS,
				payload: result,
				history,
			});
		} else {
			notification('error', result.error || result);
			yield put({ type: actions.LOGIN_ERROR });
		}
	});
}

export function* registerRequest() {
	yield takeEvery('REGISTER_REQUEST', function* ({ payload }) {
		const { history, userInfo } = payload;
		const result = yield call(AuthHelper.register, userInfo);
		if (result.token) {
			yield put({
				type: actions.REGISTER_SUCCESS,
				payload: result,
				history,
			});
		} else {
			notification('error', result.error || result);
			yield put({ type: actions.REGISTER_ERROR });
		}
	});
}

export function* loginSuccess() {
	yield takeEvery(actions.LOGIN_SUCCESS, function*({ payload, history }) {
		yield setToken(payload.token);
	});
}

export function* registerSuccess() {
	yield takeEvery(actions.REGISTER_SUCCESS, function*({ payload, history }) {
		yield setToken(payload.token);
		if (history) {
			history.push('/dashboard');
		}
	});
}

export function* loginError() {
	yield takeEvery(actions.LOGIN_ERROR, function*() {});
}

export function* registerError() {
	yield takeEvery(actions.REGISTER_ERROR, function*() {});
}

export function* logout() {
	yield takeEvery(actions.LOGOUT, function*() {
		clearToken();
		yield put(push('/'));
	});
}
export function* checkAuthorization() {
	yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
		const token = getToken().get('idToken');
    if (token && checkToken(token)) {
			yield put({
				type: actions.LOGIN_SUCCESS,
				payload: { token },
				token,
				profile: 'Profile',
			});
		} else {
      clearToken();
      if (window.location.href.indexOf('/dashboard/') > -1 || window.location.href.indexOf('/properties/') > -1) {
        yield put(push('/'));
      }
    }
	});
}

const doRequestPasswordReset = async payload => {
	const body = {
		data: payload
	}
	return await SuperFetch.post(apiUrls.requestPasswordReset, body)
	  .then(res => res)
	  .catch(error => ({
		error: JSON.stringify(error)
	  }));
};
export function* requestPasswordReset(action) {
	const response = yield call(doRequestPasswordReset, action.payload);
	if (response && response.success === 'yes') {
	  yield put(actions.requestPasswordResetSuccess(response));
	} else {
	  yield put(actions.requestPasswordResetFailed(response));
	}
}

const doChangePasswordRequest = async payload => {
	const body = {
		data: payload
	}
	return await SuperFetch.post(apiUrls.changePasswordRequest, body)
	  .then(res => res)
	  .catch(error => ({
		error: JSON.stringify(error)
	  }));
};
export function* changePasswordRequest(action) {
	const response = yield call(doChangePasswordRequest, action.payload);
	if (response && response.success) {
	  yield put(actions.changePasswordRequestSuccess(response));
	} else {
	  yield put(actions.changePasswordRequestFailed(response));
	}
}

const doGetVerifyActivation = async payload => {
	return await SuperFetch.post(apiUrls.verifyActivation, payload)
		.then(res => res)
		.catch(error => ({
			error: JSON.stringify(error)
		}));
};
export function* getVerifyActivation(action) {
	const response = yield call(doGetVerifyActivation, action.payload);
	if (response && response.result !== "invalid") {
		yield put(actions.getVerifyActivationSuccess(response));
	} else {
		yield put(actions.getVerifyActivationFailed(response));
	}
}

const doSetPassword = async payload => {
	return await SuperFetch.post(apiUrls.activatePassword, payload)
		.then(res => res)
		.catch(error => ({
			error: JSON.stringify(error)
		}));
};
export function* setPassword(action) {
	const response = yield call(doSetPassword, action.payload);
	if (response && response.result !== "invalid") {
		yield setToken(response.token);
		yield put(actions.setPasswordSuccess(response));
	} else {
		yield put(actions.setPasswordFailed(response));
	}
}

export default function* rootSaga() {
	yield all([
		fork(checkAuthorization),
		fork(loginRequest),
		fork(loginSuccess),
		fork(loginError),
		fork(registerRequest),
		fork(registerSuccess),
		fork(registerError),
		fork(logout),
		takeEvery(actions.REQUEST_PASSWORD_RESET, requestPasswordReset),
		takeEvery(actions.REQUEST_CHANGE_PASSWORD, changePasswordRequest),
		takeEvery(actions.GET_VERIFY_ACTIVATION, getVerifyActivation),
		takeEvery(actions.DO_SET_PASSWORD, setPassword)
	]);
}



// WEBPACK FOOTER //
// ./src/redux/auth/saga.js